import React from "react";
import { Link } from "gatsby";
import resolveLink from "src/utils/resolveLink";

const FooterLink = (item) => {
  var urlTarget = "";

  if (item.target?.cached_url.includes("knowledge-centre")) {
    urlTarget = "";
  } else {
    urlTarget = "_blank";
  }
  return (
    <Link
      to={
        item.target?.linktype === "story"
          ? resolveLink(item.target?.cached_url)
          : item.target?.cached_url
      }
      target={item.target?.linktype !== "story" ? urlTarget : ""}
      className="relative w-1/2 cursor-pointer overflow-hidden transition-opacity duration-300 hover:!opacity-100 group-hover:opacity-50"
    >
      <div className="before:bg-brightgreen hover:text-brightgreen relative -left-5 py-1.5 pl-5 text-sm tracking-[-0.02em] text-white transition-all duration-300 before:absolute before:top-4 before:-left-5 before:block before:h-px before:w-8 hover:left-1">
        {item.name}
      </div>
    </Link>
  );
};

export default FooterLink;
